<ng-container [formGroup]="instructionForm">
  <form [formGroup]="instructionForm" class="instruction-form">
      <div class="form-wrapper input-wrapper">
          <!-- Name -->
          <mat-form-field class="form-field">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" placeholder="Enter Instruction name">
              @if (instructionForm.get('name')?.hasError('required')) {
              <mat-error>
                  Instruction Name is required
              </mat-error>
              }
          </mat-form-field>

          <!-- Description -->
          <mat-form-field class="form-field">
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description" cdkTextareaAutosize
                  cdkAutosizeMinRows="3"></textarea>

              @if (instructionForm.get('description')!.hasError('required')) {
              <mat-error>Instruction description is required.</mat-error>
              }
          </mat-form-field>

          <!-- Keywords -->
          <keywords-controller [allKeywords]="allKeywords()" [parentForm]="instructionForm"/>
      </div>
  </form>
</ng-container>
